import axios from "axios";
// Relativo de proposito -- ver frontend/src/config.js (auditoria de 18/08/2026).
const BASE = "/api/v1";
export const authApi    = axios.create({ baseURL: BASE });
export const schedApi   = axios.create({ baseURL: BASE + "/scheduling" });
export const financeApi = axios.create({ baseURL: BASE + "/finance" });
export const estabApi   = axios.create({ baseURL: BASE + "/establishments" });
const addAuth = (i) => i.interceptors.request.use((c) => {
  const t = (sessionStorage.getItem("access_token")||localStorage.getItem("access_token"));
  if (t) c.headers.Authorization = "Bearer " + t;
  return c;
});
[schedApi, financeApi, estabApi].forEach(addAuth);
